import { SET_SELECTED_ROWS } from './actionTypes';

const setSelectedRows = (isSelected, rows) => ({
    type: SET_SELECTED_ROWS,
    rows,
    isSelected,
});

export default setSelectedRows;
